// extracted by mini-css-extract-plugin
module.exports = {"logoAddress":"logoAddress_logoAddress__AJwbU","address":"logoAddress_address__zUo7h","cta":"logoAddress_cta__GKh8y"};